import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'


class Modal extends React.Component {
	componentDidMount() {
		document.addEventListener('keydown', this.handleKeyDown)
		document.body.style.overflow = 'hidden'
	}
	componentWillUnmount() {
		document.removeEventListener('keydown', this.handleKeyDown)
		document.body.style.overflow = ''
	}
	handleKeyDown = (e) => {
		if (e.key === 'Escape') {
			this.props.onClose()
		}
	}
	handleOverlayClick = (e) => {
		if (e.target === e.currentTarget) this.props.onClose()
	}
	render() {
		const modalRoot =
			document.getElementById('modal-root') ||
			(() => {
				const el = document.createElement('div')
				el.id = 'modal-root'
				document.body.appendChild(el)
				return el
			})()

		return ReactDOM.createPortal(
			<div
				role='dialog'
				aria-modal='true'
				className='modal-overlay'
				onClick={this.handleOverlayClick}
				style={{
					position: 'fixed',
					inset: 0,
					background: 'rgba(0,0,0,0.5)',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					zIndex: 1050,
					padding: 16,
				}}
			>
				<div
					className='modal-content'
					style={{
						background: '#fff',
						borderRadius: 8,
						width: '100%',
						maxWidth: 560,
						boxShadow:
							'0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05)',
					}}
				>
					<div
						className='modal-header'
						style={{
							padding: '16px 20px',
							borderBottom: '1px solid #eee',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
						}}
					>
						<h3 style={{ margin: 0 }}>{this.props.title}</h3>
						<button
							aria-label='Close'
							onClick={this.props.onClose}
							style={{
								border: 'none',
								background: 'transparent',
								fontSize: 22,
								lineHeight: 1,
								cursor: 'pointer',
							}}
						>
							×
						</button>
					</div>

					<div className='modal-body' style={{ padding: 20 }}>
						{this.props.children}
					</div>
				</div>
			</div>,
			modalRoot
		)
	}
}

Modal.propTypes = {
	title: PropTypes.string.isRequired,
	onClose: PropTypes.func.isRequired,
	children: PropTypes.node,
}

export default Modal